import { TypedCustomerApi } from "@novel/shared/typedCustomerApi/TypedCustomerRoutes";
import { customerCsrfPropertyName } from "@novel/shared/utils/appConstants";
import { getCustomerCsrfToken } from "../../../shared/utils/getCustomerCsrfToken";

export const typedFrontendGalleryApi = new TypedCustomerApi("", [
    // using app prefixed host right now because otherwise cookie not shared
    (endpoint, requestConfig) => {
        const csrfToken = getCustomerCsrfToken();
        return {
            ...requestConfig,
            headers: {
                ...requestConfig.headers,
                ...(!csrfToken ? {} : { [customerCsrfPropertyName]: csrfToken }),
            },
        };
    },
]);
